import {createI18n} from 'vue-i18n'
import en from './Locales/en.json';
import nl from './Locales/nl.json';

const messages = { en, nl };

const getBrowserLocale = () => {
  const lang = navigator.language || navigator.userLanguage;
  const shortLang = lang ? lang.substring(0, 2) : 'en';
  switch (shortLang) {
    case 'nl':
      return 'nl';
    default:
      return 'en';
  }
};

export const resolveInitialLocale = () => {
  const page = window?.Inertia?.page || window?.__INITIAL_PAGE__;
  const sharedLocale = page?.props?.locale;

  if (sharedLocale && messages[sharedLocale]) {
    return sharedLocale;
  }

  const userLocale = page?.props?.auth?.user?.language;

  if (userLocale && messages[userLocale]) {
    return userLocale;
  }

  return getBrowserLocale();
};

const i18n = createI18n({
  legacy: false,
  locale: resolveInitialLocale(),
  fallbackLocale: 'en',
  messages,
});

export default i18n;
